export default __webpack_public_path__ + "static/how-big-is-the-budget-2021-129f6328a7d7b9375d4511ecb4468d70.pdf";